import { render, staticRenderFns } from "./PenCheng.vue?vue&type=template&id=41ff962e&scoped=true&"
import script from "./PenCheng.vue?vue&type=script&lang=js&"
export * from "./PenCheng.vue?vue&type=script&lang=js&"
import style0 from "./PenCheng.vue?vue&type=style&index=0&id=41ff962e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ff962e",
  null
  
)

export default component.exports